export default "__VITE_ASSET__kUVix6iD__"